import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Therapist } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_THERAPIST_KEY = 'get-therapist-by-id';

export const useGetTherapistById = (id: number) => {
  return usePermittedQuery<Therapist>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/therapist/${id}`,
    {},
    [GET_THERAPIST_KEY, id],
    {
      enabled: typeof id === 'number' && id >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
